
import { Province, Industry, CompanySize } from './types';

export const PROVINCES = Object.values(Province);
export const INDUSTRIES = Object.values(Industry);
export const COMPANY_SIZES = Object.values(CompanySize);

export const MAJOR_HUBS: Record<Province, string[]> = {
  [Province.GAUTENG]: ["Johannesburg", "Pretoria", "Sandton"],
  [Province.WESTERN_CAPE]: ["Cape Town", "Stellenbosch", "Paarl"],
  [Province.KWAZULU_NATAL]: ["Durban", "Umhlanga", "Pietermaritzburg"],
  [Province.EASTERN_CAPE]: ["Gqeberha", "East London"],
  [Province.FREE_STATE]: ["Bloemfontein"],
  [Province.LIMPOPO]: ["Polokwane"],
  [Province.MPUMALANGA]: ["Mbombela"],
  [Province.NORTH_WEST]: ["Rustenburg"],
  [Province.NORTHERN_CAPE]: ["Kimberley"]
};
